import React from 'react';
import 'twin.macro';
import { useSchoolsTrash } from '@teetsh/app/src/containers/UserSettings/Trash/Schools/useSchoolsTrash';
import { useRestoreSchool } from '@teetsh/app/src/containers/UserSettings/Trash/Schools/useRestoreSchool';
import { RestorableList } from '@teetsh/app/src/containers/UserSettings/Trash/components/RestorableList';
import { RestorableSchool } from '@teetsh/app/src/types/school';

export function SchoolsRestorableList() {
  const { data = [] } = useSchoolsTrash();
  const restore = useRestoreSchool();

  const Details = ({ city }: RestorableSchool) => (
    <div tw="font-light">{city}</div>
  );

  return (
    <RestorableList<RestorableSchool>
      items={data}
      restore={restore}
      cardFileDetails={Details}
      tableFileDetails={({ row }) => Details(row.original)}
    />
  );
}
